import { render, staticRenderFns } from "./digital.vue?vue&type=template&id=fe4b71e4&scoped=true&"
import script from "./digital.vue?vue&type=script&lang=js&"
export * from "./digital.vue?vue&type=script&lang=js&"
import style0 from "./digital.vue?vue&type=style&index=0&id=fe4b71e4&prod&lang=scss&"
import style1 from "./digital.vue?vue&type=style&index=1&id=fe4b71e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4b71e4",
  null
  
)

export default component.exports